import { useEffect } from 'react';
import { useAuthStore } from '../../features/auth/stores/authStore';
import { useQueryClient } from '@tanstack/react-query';

export function useResetErrorStateOnLogout() {
  const { isAuthenticated } = useAuthStore();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!isAuthenticated) {
      // Clear React Query cache on logout
      queryClient.clear();
      // Add other error clear calls here if needed
    }
  }, [isAuthenticated, queryClient]);
}
